'use client'

import { useMutation } from "@tanstack/react-query"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { API_Data_Delete_Favorite_Response } from "@/interfaces/api/favorites/favorites_types"
import { deleteFavorite } from "../requests/favorites"

export const useDeleteFavorite = () => useMutation<API_Data_Delete_Favorite_Response, API_Error, { profileId: string, gameId: string }>({
    retry: false,
    mutationFn: ({ profileId, gameId }) => deleteFavorite(profileId, gameId)
})